import React from 'react';
import { m } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { StarRating } from '../ui/StarRating';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-white" data-id="element-116" data-mp="hvz4dzzy5igi">
      {/* Slim brand bar */}
      <div className="border-b-[3px] border-naranja" data-id="element-117" data-mp="mutxburmonec">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-4 py-4 sm:px-6" data-id="element-118" data-mp="mrxz05bvbwpd">
          <span className="font-heading text-lg font-bold text-azul" data-id="element-119" data-mp="qtj61a1q1grn">🏐 Voley-Pro 360</span>
        </div>
      </div>

      <div className="relative bg-gradient-to-b from-bg-secondary to-white pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-120" data-mp="10lfi5p0n77ev">
        <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-121" data-mp="15ks4m8nlqcgx">
          <m.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-122" data-mp="1ajd425v14s4b">
            <SectionTag icon="🏐" data-id="element-123" data-mp="9o2rvr4dz0pp">Para entrenadores que quieren dejar de improvisar</SectionTag>
          </m.div>

          <m.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="mt-5 font-heading text-4xl font-bold uppercase leading-[1.08] tracking-tight text-azul sm:text-5xl md:text-6xl" data-id="element-124" data-mp="4nof5vrub2lc">
            Todo tu año de <span className="text-naranja" data-id="element-125" data-mp="sdshlztakwar">Voleibol</span> resuelto.
          </m.h1>

          {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
          <img src="https://cdn.magicpatterns.com/uploads/1hSP4dbiLE1qtF5VJVuZT9/ChatGPT_Image_27_ago_2026__15_25_38-removebg-preview.webp" alt="VOLEY-PRO 360: El Sistema Sesión en Mano — colección de 6 tomos y 5 bonos" width={500} height={500} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-md sm:max-w-lg" data-id="element-126" data-mp="infsrveg2gyt" />

          <m.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.18
        }} className="mt-6 max-w-2xl border-l-4 border-naranja px-4 text-left text-base leading-relaxed text-muted sm:text-lg" data-id="element-127" data-mp="35l0le26h0v8d">
            Ten siempre una sesión lista para llevar al pabellón, aunque sea domingo a las 22:00 y todavía
            no hayas preparado nada. VOLEY-PRO 360 reúne 6 tomos con sesiones reales listas{' '}
            <span className="font-semibold text-gris-oscuro" data-id="element-128" data-mp="27x9pm6mz37fg">"Sesión en Mano"</span> para que abras el PDF,
            veas el ejercicio y sepas exactamente qué hacer en tu próximo entrenamiento.
          </m.p>

          <m.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.26
        }} className="mt-7 flex flex-col items-center" data-id="element-129" data-mp="6650bh8iiiya">
            <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-130" data-mp="1vo25a7nwixke">
              Quiero Voley-Pro 360 por 17,99€
            </PrimaryButton>
            <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-131" data-mp="1qm30qugfdulv">
              ⚡ Acceso inmediato · 📱 Formato digital · Úsalo desde móvil, tablet u ordenador
            </p>
          </m.div>

          <m.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.34
        }} className="mt-6 flex flex-col items-center gap-2 text-sm text-muted sm:flex-row sm:gap-4" data-id="element-132" data-mp="20k0q5la0txg2">
            <div className="flex items-center gap-2" data-id="element-133" data-mp="2oamxfac7bdp0">
              <StarRating data-id="element-134" data-mp="2jclecperzedj" />
              <span className="font-medium text-gris-oscuro" data-id="element-135" data-mp="2jcbmewa66x57">4,9/5</span>
              <span data-id="element-136" data-mp="txndj50sfxbx">· +500 reseñas verificadas</span>
            </div>
            <div className="hidden h-4 w-px bg-gris-claro sm:block" aria-hidden="true" data-id="element-137" data-mp="txx2cpa3jyg1" />
            <div className="flex items-center gap-1.5 text-naranja" data-id="element-138" data-mp="p050p3jngxyn">
              <FlameIcon size={16} className="fill-naranja" data-id="element-139" data-mp="qgivu4z66l6v" />
              <span data-id="element-140" data-mp="veu265q9adkc">42 entrenadores eligieron Voley-Pro 360 hoy</span>
            </div>
          </m.div>
        </div>
      </div>
    </header>;
}